import { Router } from '@lightningjs/sdk';
import request, { axiosInstance } from '../index';
import { getDevice } from '../../utils/device';

export const getUsersProfile = () =>
  request({
    url: `/users/profile`,
    method: 'GET',
  });

export const logoutUser = (userId) =>
  request({
    url: `/users/${userId}/logout`,
    method: 'GET',
  });

export const authenticateUser = async (email, password, errorCallback) => {
  const loginData = {
    email: email,
    password: password,
  };
  let platform = navigator.platform;
  const userAgent = navigator.userAgent;
  let version;
  let device = getDevice();
  if (userAgent.includes('Tizen')) {
    const tizenIndex = userAgent.indexOf('Tizen');
    const versionStart = tizenIndex + 'Tizen '.length;
    version = userAgent.slice(versionStart, userAgent.indexOf(' ', versionStart));
    // Remove closing parenthesis if present
    version = version.replace(')', '');
  }
  if (userAgent.includes('Web0S')) {
    const webOSIndex = userAgent.indexOf('Web0S');
    const versionStart = webOSIndex + 'Web0S'.length + 1; // Add 1 to skip the semicolon
    version = userAgent.slice(versionStart, userAgent.indexOf(';', versionStart));

    // Assuming you have the getDevice() function defined elsewhere
    device = getDevice();
    // Assuming you have the platform variable defined elsewhere
    platform = 'WebOS';
  }

  const response = await fetch('https://stream.livingscriptures.com/api/v4/authenticate', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'LSI-Client-Device': device,
      'LSI-Client-Platform': platform,
      'LSI-Client-Version': version,
    },
    body: JSON.stringify(loginData),
  });

  if (response.ok) {
    const data = await response.json();
    localStorage.setItem('userToken', data.token);
    // axiosInstance.defaults.params.token = data.token;
    Router.navigate('profile');
  } else {
    response.json().catch(async (errorData) => {
      console.error('Authentication failed:', response.status);
      let errorMessage = 'Authentication failed';
      if (errorData && errorData.message) {
        errorMessage = errorData.message;
      }

      errorCallback(errorMessage);
    });
  }
};
